import { useSyncExternalStore } from 'react';
import { subscribeToWindowLevelEvents } from '~/domain/events/windowLevelSubscription';
import { Image3D } from '~/domain/patient/image3d';
import { WindowLevel } from '~/domain/patient/windowLevel';

/**
 * Hook that subscribes to window/level changes via the domain event bus.
 * Uses useSyncExternalStore to efficiently bridge external state with React.
 *
 * @param image - The image to get window level from
 * @returns The current WindowLevel, or undefined if no image
 */
export function useWindowLevelSubscription(
    image: Image3D | undefined
): WindowLevel | undefined {
    const seriesUid = image?.seriesUid;

    return useSyncExternalStore(
        (onStoreChange) =>
            seriesUid
                ? subscribeToWindowLevelEvents(seriesUid, onStoreChange)
                : () => {},
        () => image?.windowLevel,
        () => undefined
    );
}
